import React from 'react';
import ReactDOM from 'react-dom';
import videojs from 'video.js';
const vjsComponent = videojs.getComponent('Component');
class Title extends vjsComponent {
    constructor(player, options, title) {
        super(player, options);
        /* Bind the current class context to the mount method */
        this.mount = this.mount.bind(this);
        /* When player is ready, call method to mount React component */
        player.ready(() => {
            this.mount(title);
        });
        /* Remove React root when component is destroyed */
        this.on('dispose', () => {
            ReactDOM.unmountComponentAtNode(this.el());
        });
    }
    mount(title) {
        ReactDOM.render(React.createElement(React.Fragment, null, title), this.el());
    }
}
export default Title;
//# sourceMappingURL=Title.js.map